// extracted by mini-css-extract-plugin
export default {"two-column-list":"ServiceSelectionPopup_two-column-list__dhJ93"};